import Vue from 'vue';
import Router from 'vue-router';
import VueScrollTo from 'vue-scrollto';

Vue.use(Router);

export default new Router({
  routes: [],
	mode: 'history',
  scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
          VueScrollTo.scrollTo(to.hash, 700);
          return { selector: to.hash }
      } else if (savedPosition) {
          return savedPosition;
      } else {
          return { x: 0, y: 0 }
      }
  }
})
